import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = async () => {
    if (!localStorage.getItem("sm_token")) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setRestaurant(data.restaurant);
    } catch {
      localStorage.removeItem("sm_token");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMe();
  }, []);

  const applySession = (data) => {
    localStorage.setItem("sm_token", data.token);
    setUser(data.user);
    setRestaurant(data.restaurant || null);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    applySession(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    applySession(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("sm_token");
    setUser(null);
    setRestaurant(null);
    window.location.href = "/";
  };

  const refreshRestaurant = async () => {
    const { data } = await api.get("/auth/me");
    setRestaurant(data.restaurant);
    return data.restaurant;
  };

  return (
    <AuthContext.Provider
      value={{ user, restaurant, loading, login, register, logout, refreshRestaurant, setRestaurant }}
    >
      {children}
    </AuthContext.Provider>
  );
}
